import { AxiosError } from 'axios';
import { useCustomMutation } from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import { PUT_CANCEL_PROFILE_AMENDMENT_REQUEST_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export enum ProfileAmendmentRequestStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Incomplete = 'INCOMPLETE',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}
export interface CancelProfileAmendmentRequest {
  status: ProfileAmendmentRequestStatus;
  uuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePutCancelProfileAmendmentRequest = ({ onSuccess, onError }: Input = {}) => {
  const putCancelProfileAmendmentRequest = async (reqBody: CancelProfileAmendmentRequest) => {
    await axiosClient.put<void>(PUT_CANCEL_PROFILE_AMENDMENT_REQUEST_URL(reqBody.uuid), {
      status: reqBody.status,
    });
  };

  return useCustomMutation(putCancelProfileAmendmentRequest, {
    onSuccess,
    onError,
  });
};
